module.exports = __webpack_public_path__ + "static/media/mariadb.512x340.abcd075c.png";